// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessingRuleDto } from './IProcessingRuleDto';
import {
    IProcessingRuleDtoFromJSON,
    IProcessingRuleDtoFromJSONTyped,
    IProcessingRuleDtoToJSON,
    IProcessingRuleDtoToJSONTyped,
} from './IProcessingRuleDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageProcessingRuleDto
 */
export interface IPageProcessingRuleDto {
    /**
     * 
     * @type {number}
     * @memberof IPageProcessingRuleDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageProcessingRuleDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageProcessingRuleDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IProcessingRuleDto>}
     * @memberof IPageProcessingRuleDto
     */
    content?: Array<IProcessingRuleDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageProcessingRuleDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageProcessingRuleDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageProcessingRuleDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageProcessingRuleDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageProcessingRuleDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageProcessingRuleDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageProcessingRuleDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageProcessingRuleDto interface.
 */
export function instanceOfIPageProcessingRuleDto(value: object): value is IPageProcessingRuleDto {
    return true;
}

export function IPageProcessingRuleDtoFromJSON(json: any): IPageProcessingRuleDto {
    return IPageProcessingRuleDtoFromJSONTyped(json, false);
}

export function IPageProcessingRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageProcessingRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IProcessingRuleDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageProcessingRuleDtoToJSON(json: any): IPageProcessingRuleDto {
    return IPageProcessingRuleDtoToJSONTyped(json, false);
}

export function IPageProcessingRuleDtoToJSONTyped(value?: IPageProcessingRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IProcessingRuleDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

